import { formatCurrency } from '@angular/common';
import { inject, Pipe, PipeTransform } from '@angular/core';
import { I18nService } from '@app/core/services';
import { CurrencyService } from '@app/core/services/currency/currency.service';

@Pipe({
  name: 'formatCurrency',
  standalone: true,
})
export class FormatCurrencyPipe implements PipeTransform {
  private i18nService: I18nService = inject(I18nService);
  private currencyService: CurrencyService = inject(CurrencyService);
  transform(value: number | string, currency_code?: string, showCurrencyCode?: boolean): string {
    if (!currency_code) {
      currency_code = this.currencyService.currentCurrency();
    }
    if (typeof value === 'string') {
      value = value.replace(',', '.');
    }
    return formatCurrency(
      Number(value),
      this.i18nService.language,
      showCurrencyCode ? this.currencyService.getCurrentCurrencySymbol(currency_code) : '',
      currency_code,
      '1.2-2'
    );
  }
}
